import { render, staticRenderFns } from "./CountryTargetBubble.vue?vue&type=template&id=f64a50ca&"
import script from "./CountryTargetBubble.vue?vue&type=script&lang=js&"
export * from "./CountryTargetBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports